<template>
  <div id="app" class="menu">
    <mt-header fixed title="筑富协同办公平台">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div
        id="content"
        class="content"
        style="background: none"
        v-else
        :style="{
        height: 'calc(100vh - 50px)',
        background: '#f6f6f6'
      }"
    >
      <div>
        <div class="menu-head">
          <img class="img-full" src="~@/assets/images/menu/index.png" />
        </div>
      </div>
      <div class="main_content" style="display: flex; flex-direction: column">
        <div
            class="subscribe"
        >
          <div class="titleBox">
            <img
                class="icon"
                :src="require(`@/assets/login-index/indexICON5.png`)"
            />
            <div class="title_home">流程</div>
          </div>
          <div class="sixthContent" style="justify-content: space-around">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/noHandleList')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON17.png`)"
              />
              <div class="right">
                <div class="text">未审批</div>
                <div v-if="proNum > 0" class="badge">{{ proNum }}</div>
              </div>
            </div>
            <div class="line"></div>
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/passList')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">审批通过</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/nopassList')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON10.png`)"
              />
              <div class="right">
                <div class="text">审批未通过
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tabModule from "@/components/footerBar/index.vue";
import request from "@/utils/keyCloakRequest";
import {getLocalData} from "@/utils/sessionData";
export default {
  components: {
    "v-tab-module": tabModule
  },
  beforeMount() {},
  data() {
    return {
      proNum: 0,// 流程审核待办数
      isLoading: false,
      messageNum: 0,
      analysisData: {},
      userId: null,
      userInfo: {},
      roleId: null,
      timer: null   // 定时器对象
    };
  },
  // 版本更新
  created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.roleId = this.userInfo.role.roleId
    this.userId = this.userInfo.userId
    this.getHomeCount();
  },
  mounted() {
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  computed: {
  },
  methods: {
    goBack() {
      this.$router.push("/home");
    },
    // 启动轮询
    startPolling() {
      this.timer = setInterval(() => {
        this.getHomeCount();
      }, 30000); // 30秒轮询一次
      this.getHomeCount(); // 立即执行一次
    },
    // 停止轮询
    stopPolling() {
      clearInterval(this.timer);
    },
    getHomeCount(){
      request({
        url: "getAppHomeNum?userId="+this.userId,
        method: "get"
      }).then(  response => {
        this.docPsNum=response.docPsNum,  // 公文批示待办数
            this.docNum=response.docNum,    // 公文拟办待办数
            this.proNum=response.proNum// 流程审核待办数
      })
    },
    linkUrl(url, params) {
      this.$router.push({
        path: url,
        query: params
      });
    }
  },
};
</script>
<style lang="less" scoped>
.right {
  position: relative;
  margin-left: 8px;
}
.badge {
  /* 原有样式保留 */
  position: absolute;
  top: -8px;
  right: -50px;
  min-width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  background-color: #f56c6c;
  color: white;
  text-align: center;
  padding: 0 4px;

  /* 新增字体放大样式 */
  font-size: 30px;  /* 原12px调整为14px */
  font-weight: bold;  /* 加粗显示 */
}
</style>
